import { styled } from '@mui/material/styles';
import { Box, Typography, Button, TextField, Select, TableCell, TableRow } from '@mui/material';

// ============================================
// Controls Row
// ============================================
export const ControlsRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: '16px',
});

export const PageSizeGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const PageSizeLabel = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#737373',
  whiteSpace: 'nowrap',
});

export const PageSizeSelect = styled(Select)({
  height: '48px',
  minWidth: '88px',
  backgroundColor: '#fff',
  borderRadius: '8px',
  fontSize: '16px',
  color: '#737373',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#d9d9d9',
  },
});

export const SearchInput = styled(TextField)({
  width: '320px',
  '& .MuiOutlinedInput-root': {
    height: '48px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    fontSize: '16px',
    '& fieldset': {
      borderColor: '#d9d9d9',
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#a6a6a6',
    opacity: 1,
  },
});

// ============================================
// Table
// ============================================
export const TableWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const HeaderCell = styled(TableCell)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#262626',
  textAlign: 'center',
  padding: '12px',
  backgroundColor: '#f2f2f2',
  borderBottom: '1px solid #d9d9d9',
  whiteSpace: 'nowrap',
  width: '20%',
  '&:first-of-type': {
    borderTopLeftRadius: '8px',
  },
  '&:last-of-type': {
    borderTopRightRadius: '8px',
  },
});

export const BodyCell = styled(TableCell)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
  textAlign: 'center',
  padding: '16px 12px',
  borderBottom: '1px solid #d9d9d9',
  whiteSpace: 'nowrap',
  width: '20%',
});

export const DataRow = styled(TableRow)({
  backgroundColor: '#fff',
});

export const DeltaText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'delta',
})(({ delta }) => {
  let color = '#262626';
  if (delta > 0) color = '#55c982';
  else if (delta < 0) color = '#ee735a';
  return {
    fontSize: '16px',
    fontWeight: 500,
    color,
  };
});

// ============================================
// Pagination
// ============================================
export const PaginationContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
  width: '100%',
  paddingTop: '8px',
});

export const PageButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isActive',
})(({ isActive }) => ({
  minWidth: '40px',
  width: '40px',
  height: '40px',
  padding: '10px',
  fontSize: '16px',
  fontWeight: 500,
  color: isActive ? '#fff' : '#262626',
  backgroundColor: isActive ? '#58b9c1' : '#fff',
  border: isActive ? 'none' : '1px solid #d9d9d9',
  borderRadius: '4px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: isActive ? '#4aa8b0' : '#f5f5f5',
  },
}));

export const NavButton = styled(Button)({
  minWidth: '40px',
  width: '40px',
  height: '40px',
  padding: '10px',
  backgroundColor: '#fff',
  border: '1px solid #d9d9d9',
  borderRadius: '4px',
  color: '#262626',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
});

export const EllipsisText = styled(Typography)({
  fontSize: '16px',
  color: '#737373',
  padding: '0 4px',
});
